import { RS_WAYS_TO_NUMBER } from '../constants';
import { getRoutePolylineCoordinates, getRouteStationsCoordinates } from './';

export const getExtendedRoute = async(route, trips, stops, stopTimes) => ({
  ...route,
  routeWayCoordinates: await getRoutePolylineCoordinates(
    route,
    trips,
    RS_WAYS_TO_NUMBER.TOUR
  ),
  routeRoundWayCoordinates: await getRoutePolylineCoordinates(
    route,
    trips,
    RS_WAYS_TO_NUMBER.RETURN
  ),
  routeWayStations: getRouteStationsCoordinates(
    route,
    trips,
    stops,
    stopTimes,
    RS_WAYS_TO_NUMBER.TOUR
  ),
  routeRoundWayStations: getRouteStationsCoordinates(
    route,
    trips,
    stops,
    stopTimes,
    RS_WAYS_TO_NUMBER.RETURN
  ),
});

export default getExtendedRoute;
